import React, { FunctionComponent, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Result } from '../helper/models/getallrestaurant'
import { ImageProcess } from '../helper/services/imageProcess'
const improcess = new ImageProcess()
const AllRestaurant = () => {
  const [result, setResult] = useState<Result[]>([])

  useEffect(() => {
    let body = { limit: 12 }
    const api = async () => {
      const data = await fetch(
        'https://api.munchies.com.bd/parse/functions/getRestaurants',
        {
          method: 'POST',
          headers: {
            'X-Parse-Application-Id': 'food',
          },
          body: JSON.stringify(body),
        }
      )
      const jsonData = await data.json()

      setResult(jsonData.result)
    }
    api()
  }, [])
  return (
    <div className="px-16 text-white bg-black">
      <p className="text-2xl text-cyan-500">All Restaurants</p>
      <div className="flex-wrap grid-flow-col text-cyan-700" key={'results'}>
        {result &&
          result.map((e, index) =>
            index > 11 ? (
              <></>
            ) : (
              <Link to={`/restaurant/${e.objectId}`} key={e.objectId}>
                <RestaurantLists key={e.objectId} restaurantList={e} />
              </Link>
            )
          )}
      </div>
    </div>
  )
}

export default AllRestaurant

const RestaurantLists: FunctionComponent<{ restaurantList: Result }> = (
  restaurantList
) => {
  return (
    <div
      style={{ width: '25%', height: '200px' }}
      className="inline-grid pr-4 my-4 overflow-hidden "
    >
      <img
        src={improcess.process(restaurantList.restaurantList.banner_image)} //
        alt={restaurantList.restaurantList.objectId}
        style={{ height: '150px', width: '90%' }}
      ></img>
      <p style={{ width: '90%' }} className="text-white text-ellipsis">
        {restaurantList.restaurantList.name}
      </p>
      <p className="text-ellipsis" style={{ width: '90%' }}>
        {restaurantList.restaurantList.cuisines}
      </p>
    </div>
  )
}
